import { restApi } from '../api/restApiSlice';

export const oversightApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: () => ({ url: `/v3/events`, method: 'GET' }),
      providesTags: ['events'],
    }),
  }),
});

export const { useGetEventsQuery } = oversightApiSlice;
